import styled from 'styled-components'
import { colors } from '@77sol-ui/tokens'
import { Select } from '@77sol-ui/molecules'

export const SelectItemButton = styled(Select.Item)`
  color: ${colors.blue[300]};
  font-weight: 500;
`
